import { ReactElement } from 'react';
import { FiFileText } from 'react-icons/fi';
import { MdAttachMoney } from 'react-icons/md';
import { TbFileExport } from 'react-icons/tb';

import { Icon } from '@iconify/react';

interface ISubmenu {
  path: string;
  title: string;
}
export interface ISibebar {
  id: number;
  icon: ReactElement;
  title: string;
  path: string;
  submenu?: ISubmenu[];
  // libera o item so para perfil admin
  adminOnly?: boolean;
}

export default [
  {
    id: 1,
    icon: <Icon icon="material-symbols:dashboard-outline-rounded" />,
    title: 'Dashboard',
    path: '/admin/dashboard',
  },
  {
    id: 2,
    icon: <Icon icon="tabler:pig-money" />,
    title: 'Movimentação Financeira',
    path: '',
    submenu: [
      { title: 'Extrato', path: '/admin/extrato' },
      { title: 'Antecipação', path: '/admin/antecipacao' },
      { title: 'Acompanhamento', path: '/admin/acompanhamento' },
    ],
  },
  {
    id: 4,
    // icon: <MdPointOfSale />,
    icon: <Icon icon="tabler:report-money" />,
    title: 'Vendas',
    path: '/admin/vendas',
  },
  {
    id: 8,
    icon: <Icon icon="tabler:calculator" />,
    title: 'Simulador de Taxas',
    path: '/admin/simulador',
  },
  // {
  //   id: 10,
  //   icon: <Icon icon="lucide:credit-card" />,
  //   title: 'Pagamentos',
  //   path: 'pagamentos'
  // },
  {
    id: 2,
    icon: <FiFileText />,
    title: 'Relatórios',
    path: '/admin/relatorio-pagamento',
  },
  {
    id: 5,
    icon: <MdAttachMoney />,
    title: 'Transações Parcelas',
    path: '/admin/transacoes-parcelas',
  },
  {
    id: 6,
    icon: <TbFileExport />,
    title: 'Exportações',
    path: '/admin/exportacoes',
  },
  {
    id: 7,
    icon: <Icon icon="bi:people" />,
    title: 'Pessoas',
    // title: 'Usuários',
    path: '/admin/pessoas',
    //path: 'usuarios',
  },
  {
    id: 9,
    icon: <Icon icon="tabler:file-percent" />,
    title: 'Planos por CPF/CNPJ',
    path: '/admin/planos',
    adminOnly: true,
  },
];
